import {get_Terrassor_INTERFACE} from "../../../../interface.js";
import * as TerrassorConst from '../../../../terrassor_const.js'

/* @ngInject */
export class SchemaEpureCreerController {
    /* @ngInject */
    constructor (ApiConst, ApiSimu, ApiExo, $scope, $sce, $compile, $element, $location, $anchorScroll) {
      this.ApiConst = ApiConst
      this.ApiSimu = ApiSimu
      this.ApiExo = ApiExo

      this.svgEpure = null

      this.$sce = $sce
      this.$scope = $scope
      this.$compile = $compile
      this.$element = $element
      this.$location = $location
      this.$anchorScroll = $anchorScroll


      this.svgEpureCreer = null;
      this.onSvgContentChange = this.onSvgContentChange.bind(this)
      // $scope.$watch('SchemaEpureCreerController.svgcontent', this.onSvgContentChange)
      $scope.$watch('SchemaEpureCreerController.svgEpureCreer', this.onSvgContentChange)


      this.checkCubaturesIsReadOnly = false;
      this.checkMouvementsIsReadOnly = false;

      this.isAddingMouvement = false;
      this.couchesMultiplesPossibles = true;
      this.purgePossible = false;
      this.typeNewCubature = new Object();
      this.typeNewCubature.code = "";


        this.exo_chantiers_id = TerrassorConst.chantierId;
        this.initialiserCubatures();
        this.initialiserNewCubature();
        this.initialiserMouvements();
        this.initialiserNewMouvement();
    }

    $onInit() {

        console.log('SchemaEpureCreerController : init')


//return;

      // L'obtention du code svg est réalisée dans SimulatorController, car il y est plus facile de traiter l'aspect asynchrone avec INTERFACE

        this.cubaturestypes = []
        this.sols = []

        this.ApiSimu.getConstCubaturesTypes()
            .then(resultArray => {
                 resultArray.forEach(item => {
                     this.cubaturestypes[this.cubaturestypes.length] = item;
                     this.cubaturestypes["id"+item.id] = item;
                    });
                this.ApiSimu.getConstSols()
                    .then(resultArray => {
                        var sol = new Object()
                        sol.nom = "Choisissez un type de sol";
                        sol.id = "0";
                        sol.code = "BIDON";
                        this.sols[0] = sol;
                        this.sols["id0"] = sol;
                        resultArray.forEach(item => {
                            if (item.code != "SURF") {
                                this.sols[this.sols.length] = item;
                                this.sols["id"+item.id] = item;
                            }
                        });

                        this.ApiSimu.getSimuExoCubatures()
                            .then(resultArray => {
                                var cubatures = [];
                                resultArray.forEach(item => {
                                    cubatures[cubatures.length] = item;
                                })
                                this.ApiSimu.getSimuExoCubaturesCouches()
                                    .then(resultArray => {
                                        var cubaturesCouches = [];
                                        resultArray.forEach(item => {
                                            cubaturesCouches[cubaturesCouches.length] = item;
                                        })
                                        if ((cubatures.length != 0) && (cubaturesCouches.length != 0)) {
                                            this.initialiserCubatures(cubatures, cubaturesCouches);
                                            this.afficherEpure();
                                            this.avertirIncoherences();

                                            this.ApiSimu.getSimuExoMouvements()
                                                .then(resultArray => {
                                                    var mouvements = [];
                                                    resultArray.forEach(item => {
                                                        mouvements[mouvements.length] = item;
                                                    })
                                                    this.ApiSimu.getSimuExoMouvementsCubatures()
                                                        .then(resultArray => {
                                                        var mouvementsCubatures = [];
                                                        resultArray.forEach(item => {
                                                            mouvementsCubatures[mouvementsCubatures.length] = item;
                                                        })
                                                        if ((mouvements.length != 0) && (mouvementsCubatures.length != 0)) {
                                                            this.initialiserMouvements(mouvements, mouvementsCubatures);
                                                            this.afficherEpure();
                                                        }
                                                    })
                                                })
                                            }
                                            //this.isCheckReadOnly();
                                    })
                            //this.parentSimulator.$timeout(() => {this.$scope.$apply()}, 500);
                            })
                    })
            })

    }

    /*
    *
    */
    doOnCheckParametrageCubaturesValid(forceValue) {

        if (this.parentSimulator.etapeParametrageCubaturesValide) {
            this.etude = get_Terrassor_INTERFACE().etude;
            this.initialiserListesCubatures();
        }

        if (forceValue !== undefined) { // can bue true | false
            if (forceValue != this.parentSimulator.etapeParametrageCubaturesValide) { // on force
                this.parentSimulator.etapeParametrageCubaturesValide = forceValue;
            }
            else { // on force, mais rien ne change
                return;
            }
        }

        if (this.parentSimulator.etapeParametrageCubaturesValide) {
            // on avertit d'un éventuel problème
            this.parentSimulator.$timeout(() => {this.avertirIncoherences()}, 500);

            this.parentSimulator.nouvelleEtapeVisualisations(TerrassorConst.ETAPE_EPURE_CUBATURES);
        }
        else {
            this.parentSimulator.nouvelleEtapeVisualisations(TerrassorConst.ETAPE_EPURE_DONNEES_GENERIQUES_OK);
        }

        // messages
        this.parentSimulator.reinitialiserMessageCreationEpure();
    }

    /*
    *
    */
    doOnCheckParametrageMouvementsValid(forceValue) {

        if (forceValue !== undefined) { // can bue true | false
            if (forceValue == this.parentSimulator.etapeParametrageMouvementsValide) { // on force, mais rien ne change
                return;
            }
            this.parentSimulator.etapeParametrageMouvementsValide = forceValue;
        }

        if (this.parentSimulator.etapeParametrageMouvementsValide) {
            this.checkCubaturesIsReadOnly = true;
            this.parentSimulator.nouvelleEtapeVisualisations(TerrassorConst.ETAPE_EPURE_MOUVEMENTS);
        }
        else {
            this.checkCubaturesIsReadOnly = false;
            this.parentSimulator.nouvelleEtapeVisualisations(TerrassorConst.ETAPE_EPURE_CUBATURES);
        }

        // messages
        this.parentSimulator.reinitialiserMessageCreationEpure();
    }

    /* ETAPE_EPURE_DONNEES_GENERIQUES = 0
* ETAPE_EPURE_CUBATURES = 1
* ETAPE_EPURE_MOUVEMENTS = 2
* ETAPE_SIMULATION = 4
*/
    /*
    * TODO stockage de l'analyse ?
    */
    doOnclickPlanification() {
        if (this.validerEpure()) {
            // sauvegarde des données simuexo vers exo
                return(this.parentSimulator.transformerTablesSimuExoEnTablesExo(this.parentSimulator.simuExo_Chantier, this.cubatures, this.mouvements, this.cubaturesMouvements))
                    .then(allResultsMouvementsCubatures => {
                        this.parentSimulator.nouvelleEtapeVisualisations(TerrassorConst.ETAPE_SIMULATION);
                    })
            }
    }

     // variable bindée : svgcontent <=>  SimulatorController.svgEpure
     onSvgContentChange() {

        // remplissage "à la mano" du container par le SVG (le svg  n'est pas connu au moment du render de l'appli, et il contient des directives ng qui doivent être évaluées)

        // l'element occurence de ce composant (schema-epure)
        var elt2 = this.$element[0]
        // au descent à son premier child
        elt2 = elt2.querySelector('#schema-epure-creer-container')
        // on remplit ce child par un méthode jQuery
        $(elt2).html(this.svgEpureCreer)
//        $(elt2).html(this.svgcontent)
        // évaluer le contenu qui contient des drectives ng-click, etc ...
        var fn = this.$compile(elt2)
        // on rattache cette partie évaluée (donc de l'angular) au scope courant
        fn(this.$scope)
    }

    /*
    * s'il existe une incohérence chantier / cubature (ou autre à déterminer)
    */
    validerIncoherences(laCubature=null) {
        var cubatures = [];
        if (laCubature) {
            cubatures[0] =  laCubature;
        }
        else {
            cubatures = this.cubatures;
        }
        var longueur = this.parentSimulator.simuExo_Chantier.longueur;
        var debut = this.parentSimulator.simuExo_Chantier.kmdebut;
        var depassement;
        var maxDepassement = 0;
        var depassementDebut;
        var maxDepassementDebut = debut+longueur;

        var cubaturesTypes = this.cubaturestypes;
        
        cubatures.forEach(function chercher(cubature, index){             
            
            // ne tester que les déblais et les remblais !!!
            var cubatureType = cubaturesTypes["id"+cubature.const_cubaturestypes_id];            
            if ((cubatureType.code == "DP") || (cubatureType.code == "DD") || (cubatureType.code == "ST")) {
                return;
                }                
            
            if ((cubature.kmfin > longueur) && (cubature.kmfin > maxDepassement)) {
                maxDepassement = cubature.kmfin;
                depassement = cubature.code;
            }
            if ((cubature.kmdebut < debut) && (cubature.kmdebut < maxDepassementDebut)) {
                maxDepassementDebut = cubature.kmdebut;
                depassementDebut = cubature.code;
            }
        })
        if (typeof(depassement) !== 'undefined') {
            var leMessage = "Attention, la cubature " + depassement + " déborde des limites de votre chantier. Vous devez corriger la longueur de ce dernier ou la cubature " + depassement + ".";
            return(leMessage);
        }
        if (typeof(depassementDebut) !== 'undefined') {
            var leMessage = "Attention, la cubature " + depassementDebut + " déborde des limites de votre chantier. Vous devez corriger le PK de début de ce dernier ou la cubature " + depassementDebut + ".";
            return(leMessage);
        }
        return(0);
    }
    /*
    * s'il existe une incohérence chantier / cubature (ou autre à déterminer)
    */
    avertirIncoherences() {
        var error = this.validerIncoherences();
        if (error) {
            alert(error);
        }
    }

    /*
    * affichage de l'épure - création du SVG hors Angular avec maj des objets - puis rafraichissement Angular
    */
afficherEpure() {

    // ici on fait l'affichage du SVG
    // on réaffiche tout le SVG à chaque demande
    var T_interface = get_Terrassor_INTERFACE()
    this.svgEpureCreer = T_interface.action({"table":"svgEpureCreer", "chantier":this.parentSimulator.simuExo_Chantier, "cubatures":this.cubatures, "cubaturesCouches":this.cubaturesCouches, "mouvements":this.mouvements, "mouvementsCubatures":this.cubaturesMouvements});

    //this.newMouvement, this.newCubaturesMouvements

    this.onSvgContentChange(); // pourquoi est-ce nécessaire (et pas ligne en dessous) ?
    //return this.$q.resolve(this.svgEpureCreer); // forcer l'update de la vue

    this.parentSimulator.reinitialiserMessageCreationEpure();

    if (this.parentSimulator.etapeParametrageMouvementsValide) {
        this.checkCubaturesIsReadOnly = true;
    }


    /*
    if (this.mouvements.length) {
        this.checkMouvementsIsReadOnly = false;
    }
*/
}


    /*
    *
    */
    addCubature(modif = false) {
        this.isAddingCubatureModif = modif;
        this.isAddingCubature = true;
    }

    /*
    *
    */
    cubatureDelete() {
        var leController = this;
        var leMessageConfirmation = "Voulez-vous vraiment supprimer cette cubature ?";
        var idCubature = this.newCubature.id;
        var mouvementsAssocies = [];
        this.mouvements.forEach(mouvement => {
            if ((mouvement.simuexo_cubatures_depart_id == idCubature) || (mouvement.simuexo_cubatures_arrivee_id == idCubature)) {
                mouvementsAssocies[mouvementsAssocies.length] = mouvement;
            }
        });
        if (mouvementsAssocies.length) {
            leMessageConfirmation = "Il existe un ou plusieurs mouvements associés à cette cubature. Si vous la supprimez, l'ensemble de ces mouvements sera également supprimé.";
        }

        if (confirm(leMessageConfirmation)) { // on y va !?
            this.isAddingCubature = false;
            this.detruireCubature(this.newCubature);
            // et on reinitialise
            this.initialiserNewCubature();
            mouvementsAssocies.forEach(mouvement => {
                leController.detruireMouvement(mouvement);
            });

        // et on réaffiche
        this.afficherEpure();
        }
    }

    /*
    *
    */
    cubatureCancel() {
        this.isAddingCubature = false;
        this.initialiserNewCubature();
    }

    /*
    *
    */
    detruireCubature(cubature) {

        var leController = this;

        // on detruit la cubature
        leController.ApiSimu.deleteSimuExoCubatures(cubature) // en base
        var i;
        for (i = this.cubatures.length - 1; i >= 0; i -= 1) { // puis dans l'objet courant
            var item = this.cubatures[i];
            if (item.id == cubature.id) {
                this.cubatures.splice(i, 1)
            }
        }

        for (i = this.cubaturesCouches.length - 1; i >= 0; i -= 1) { // puis dans l'objet courant
            var item = this.cubaturesCouches[i];
            if (item.simuexo_cubatures_id == cubature.id) {
                leController.ApiSimu.deleteSimuExoCubaturesCouches(item)
                leController.cubaturesCouches.splice(i, 1)
            }
        }
    }

    /*
    *
    */
    detruireCouche(couche) {

        var leController = this;
        this.ApiSimu.deleteSimuExoCubaturesCouches(couche);
        var i;
        for (i = this.cubaturesCouches.length - 1; i >= 0; i -= 1) {
            var item = this.cubaturesCouches[i];
            if (item.id == couche.id) {
                this.cubaturesCouches.splice(i, 1);
            }
        }

        // on commence par chercher si un mouvement est asscocié à cette couche
        var mouvementsAssocies = [];
        this.cubaturesMouvements.forEach(cubatureMouvement => {
            if (cubatureMouvement.simuexo_cubatures_couches_id == couche.id) {
                mouvementsAssocies[mouvementsAssocies.length] = leController.getMouvement(cubatureMouvement.simuexo_mouvements_id);
            }
        });

        // on detruit les mouvements associés à la couche
        mouvementsAssocies.forEach(mouvement => {
            leController.detruireMouvement(mouvement);
            });
    }

    /*
    *
    */
    majCubatures(newCubature, cubatureCouches) {

        var leController = this;

            // 1 CUBATURES
        // on ajoute ou on écrase
        var indexNewCubature = this.cubatures.length; // si ajout
        this.cubatures.forEach(function chercher(cubature, index){
            if (cubature.id == newCubature.id) {
                indexNewCubature = index; // si ecrase
            }
        })
        this.cubatures[indexNewCubature] = newCubature;

            // 2 COUCHES
        cubatureCouches.forEach(item => {
            if (item.simuexo_cubatures_id == newCubature.id)
                {
                // on ajoute ou on écrase
                var indexNewCubatureCouche = this.cubaturesCouches.length; // si ajout
                this.cubaturesCouches.forEach(function chercher(couche, index){
                    if (couche.id == item.id) {
                        indexNewCubatureCouche = index
                    }
                })
                this.cubaturesCouches[indexNewCubatureCouche] = item; // si ecrase
            }
        });

            // 3 COUCHES DETRUITES POUR FINIR (DE CETTE FACON ON NE DETRUIT PAS D'ID AVANT DE LES CREER)
        this.newCubatureCouches.forEach(item => {
            if (!item.publiee) {
                leController.detruireCouche(item);
            }
        })

        // on réaffiche
        this.isAddingCubature = false;
        this.initialiserNewCubature();
        this.afficherEpure();
    }

    /*
    * inutile
    */
    purgeChange(num) {
    }

    /*
    * clic sur le plus pour ajouter une nouvelle couche
    */
    addCouche() {
        this.initialiserNewCoucheS(); //
    }

    /*
    *
    */
    deleteCouche(couche) {

        // pour commencer, est-ce qu'on peut ..
        var cptCouches = 0;
        this.newCubatureCouches.forEach(cubatureCouche => {
            if (cubatureCouche.publiee) {
                cptCouches++;
            }
        });
        if (cptCouches < 2 ) {
            alert("Attention, une cubature doit comporter au moins une couche.");
            return;
        }

        var leController = this;
        var leMessageConfirmation = "Voulez-vous vraiment supprimer cette couche de cubature ? La suppression sera définitive après validation de la cubature.";
        //var leMessageConfirmation = "Voulez-vous vraiment supprimer cette couche de cubature ? La suppression sera définitive.";

        // on commence par chercher si un mouvement est asscocié à cette couche
        // var cubature = this.getCubature(couche.simuexo_cubatures_id); // cubature de la couche
        var mouvementsAssocies = [];
        this.cubaturesMouvements.forEach(cubatureMouvement => {
            if (cubatureMouvement.simuexo_cubatures_couches_id == couche.id) {
                mouvementsAssocies[mouvementsAssocies.length] = leController.getMouvement(cubatureMouvement.simuexo_mouvements_id);
            }
        });

        if (mouvementsAssocies.length) {
            leMessageConfirmation = "Attention, il existe un ou plusieurs mouvements associés à cette couche de cubature. Voulez-vous vraiment la supprimer ? L'ensemble des mouvements associés sera également supprimé. La suppression sera définitive après validation de la cubature.";
        }

        // on y va ! ou pas ...
        if (confirm(leMessageConfirmation)) {
            var i;
            for (i = this.newCubatureCouches.length - 1; i >= 0; i -= 1) {
                var item = this.newCubatureCouches[i];
                if (item.ordre == couche.ordre) {
                    // on cache la couche en la desactivant, de cette façon on pourra la détruire lors de la sauvegarde
                    item.publiee = 0;
                    // non !  en fait on détruit en direct, sinon c'est trop compliqué
                    // this.detruireCouche(couche, mouvementsAssocies);
                }
            }

            // this.afficherEpure(); // et on réaffiche
        }
    }


    //*********************************
	triParOrdre(x, y) {
        return(x.ordre - y.ordre);
    }

    /*
    * Clic sur le bouton valider d'une cubature
    */
    cubatureValidate() {

        var leController = this;

        // cubature trop grande ?
        var error = this.validerIncoherences(this.newCubature);
        if (error) {
            alert(error);
            return;
        }

        // VALIDATION
        // on vérifie qu'il n'y a pas de problème de cohérence de code / id
        var cubatureTmp = this.initialiserCubatureTmp(this.newCubature.code);
        if (typeof(cubatureTmp) !== 'undefined') {
            if (cubatureTmp.id != this.newCubature.id) {
                alert("Attention, le code que vous avez saisi pour cette cubature existe déjà. Si vous souhaitez modifier une cubature, cliquez sur son étiquette dans le schéma, sinon saisissez un autre code.");
                return;
            }
        }


        // problème d'ordre sur les couches
        this.newCubatureCouches.sort(this.triParOrdre);
        var cptOrdre = 1;
        var pbOrdre = false;
        var pbPurge = false;
        var pbPurgeCouche = false;
        this.newCubatureCouches.forEach(item => {
            if (item.publiee) {
                if (item.ordre != cptOrdre) {
                    pbOrdre = true;
                }
                if (leController.typeNewCubature.code == "R+") {
                    if ((item.ordre == 1) && !item.purge) {
                        pbPurge = true;
                        pbPurgeCouche = true;
                    }
                    if (item.ordre == 2) {
                        pbPurgeCouche = false;
                    }
                }
                cptOrdre++;
            }
        })
        if (pbOrdre) {
                alert("Attention, les ordres saisis sur les couches ne sont pas continus ou ne commencent pas à 1. Veuillez corriger votre saisie.");
                return;
            }
        if (pbPurge || pbPurgeCouche) {
                alert("Attention, un remblai avec purge doit intégrer une première couche de purge et au moins une couche de remblai.");
                return;
            }


        // SAUVEGARDE
        // si OK on sauve et on affiche
        this.isAddingCubature = false;

        if ((this.typeNewCubature.code != "R+") && (this.typeNewCubature.code != "R") && (this.typeNewCubature.code != "D")) {
                this.newCubature.kmdebut = 0; // on a caché sans se soucier du contenu donc on force la valeur
                this.newCubature.kmfin = 0; // on a caché sans se soucier du contenu donc on force la valeur
                }
        return this.ApiSimu.saveSimuExoCubatures(this.newCubature)
            .then(newCubature => {
                if (typeof(newCubature) !== 'undefined') {
                    this.newCubature.id = newCubature.id;
                    var allPromises = [];
                    var leController = this;
                    this.newCubatureCouches.forEach(item => {
                        if (item.publiee) {
                            item.simuexo_cubatures_id = newCubature.id;
                            if (item.ordre == 1 && (leController.typeNewCubature.code == "R+")) { //  if (item.ordre != 1 || (leController.typeNewCubature.code != "R+")) {
                                item.purge = true; // item.purge = false; // on a caché sans se soucier du contenu donc on force la valeur
                            }
                            else {
                                item.purge = false;  // item.purge = true;
                            }
                            if (leController.typeNewCubature.code == "DD") {
                                item.const_sols_id = -1; // on a caché sans se soucier du contenu donc on force la valeur : TODO => implications ?
                            }
                            var promise = leController.ApiSimu.saveSimuExoCubaturesCouches(item);
                            allPromises.push(promise)
                        }
                        else {
                        }
                    });
                    return Promise.all(allPromises)
                        .then(allResults => {
                            this.majCubatures(this.newCubature, allResults)
                        })
                }
        })
    }

    /*
    * * La nouvelle cubature suite à demande de création ou suite à clic sur cubature existante
    */
    initialiserNewCubature(codeCbt = 0) {

        // reinit des variables
        this.newCubature = new Object();
        this.newCubatureCouches = [];

        // remplissage
        if (codeCbt) {
            var cubatureTmp = this.initialiserCubatureTmp(codeCbt);

            this.newCubature.id = cubatureTmp.id;
            this.newCubature.num = Number(cubatureTmp.code.substr(cubatureTmp.code.length-2,2));
            this.newCubature.code = cubatureTmp.code;
            this.newCubature.nom = cubatureTmp.nom;
            this.newCubature.exo_chantiers_id = cubatureTmp.exo_chantiers_id;
            this.newCubature.const_cubaturestypes_id = cubatureTmp.const_cubaturestypes_id;
            this.newCubature.kmdebut  = cubatureTmp.kmdebut;
            this.newCubature.kmfin  = cubatureTmp.kmfin;
            this.newCubature.description  = cubatureTmp.description;
            this.newCubature.valid  = 1;

            this.autoriserPurgeOuPasCouchesOuPas();

            this.initialiserNewCoucheS(cubatureTmp.cubatureCouches)
        }
        else {
            this.newCubature.id = 0; // à gerer via la base !?!
            this.newCubature.num = ""; // ne sera pas utilisé pour l'écriture de la table, mais juste pour le code
            this.newCubature.code = "";
            this.newCubature.nom = "";
            this.newCubature.exo_chantiers_id = this.exo_chantiers_id;
            this.newCubature.const_cubaturestypes_id = "";
            this.newCubature.kmdebut  = "";
            this.newCubature.kmfin  = "";
            this.newCubature.description  = "";
            this.newCubature.valid  = 1;

            this.initialiserNewCoucheS()
        }
    }
    /*
    * * La nouvelle couche suite à demande de création ou suite à clic sur cubature existante (et restauration couches existantes)
    */
    initialiserNewCoucheS(tabCouches=[]) {
        if (tabCouches.length == 0) {
            var couche = new Object();
            couche.id = 0;  // à gerer via la base !?!
            couche.simuexo_cubatures_id = 0;    // à gerer via la base !?!
            couche.const_sols_id = "0";
            couche.ordre = this.newCubatureCouches.length+1;
            couche.volume = "";
            couche.purge = true;
            couche.publiee = 1;
            //this.newCubatureCouchesTMP = couche;
            this.newCubatureCouches[this.newCubatureCouches.length] = couche;
        }
        else {
            tabCouches.forEach(item => {
                var couche = new Object();
                couche.id = item.id;
                couche.simuexo_cubatures_id = item.simuexo_cubatures_id;
                couche.const_sols_id = item.const_sols_id;
                couche.ordre = item.ordre;
                couche.volume = item.volume;
                //couche.purge = item.purge;
                couche.purge = true; // on met à 1 mais on sauvegardera à 0
                if (typeof(item.publiee) != 'undefined') {
                    couche.publiee = item.publiee;
                    }
                else {
                    couche.publiee = 1;
                    }
                this.newCubatureCouches[this.newCubatureCouches.length] = couche;
            });
            this.newCubatureCouches.sort(this.triParOrdre);
        }
    }
    /*
    * Initialisation des cubatures élèves stockées en base
    */
    initialiserCubatures(cubatures, cubaturesCouches) {

        this.cubatures = [];
        this.cubaturesCouches = [];

        if ((typeof(cubatures) == 'undefined') || (typeof(cubaturesCouches) == 'undefined')) {
            return;
        }


        this.cubatures = cubatures;
        this.cubaturesCouches = cubaturesCouches;
    }

    /*
    * Initialisation des mouvements élèves stockés en base
    */
    initialiserMouvements(mouvements, cubaturesMouvements) {

        var leController = this;
        var chantier = this.chantier;

        this.mouvements = [];
        this.cubaturesMouvements = [];

        if ((typeof(mouvements) == 'undefined') || (typeof(cubaturesMouvements) == 'undefined')) {
            return;
        }

// si nécessaire, on charge les mouvements
        this.mouvements = mouvements;
        this.cubaturesMouvements = cubaturesMouvements;
/*
        // init de l'accès direct par code
        angular.forEach(mouvements, function(mouvement, key) {
            leController.mouvements[mouvement.code] = mouvement;
        })

        // init du sous-tableau "depart" et "arrivee"
        angular.forEach(cubaturesMouvements, function(cubatureMouvement, key) {
            var codeMouvement = "ERROR";
            angular.forEach(mouvements, function(mouvement, key) {
                if (mouvement.id == cubatureMouvement.simuexo_mouvements_id) {
                    codeMouvement = mouvement.code;
                    }
                })
            if (typeof(leController.cubaturesMouvements[codeMouvement]) == 'undefined') {
                leController.cubaturesMouvements[codeMouvement] = [];
            }
            if (cubatureMouvement.exo_cubatures_id == cubatureMouvement.exo_cubatures_idSource) {
                leController.cubaturesMouvements[codeMouvement]["depart"] = cubatureMouvement;
            }
            if (cubatureMouvement.exo_cubatures_id == cubatureMouvement.exo_cubatures_idCible) {
                leController.cubaturesMouvements[codeMouvement]["arrivee"] = cubatureMouvement;
            }
        })
*/

       this.doOnCheckParametrageCubaturesValid(this.parentSimulator.etapeParametrageCubaturesValide); // il y a des mouvemnts - on force la validation des cubatures wiz
    }

    /*
    *
    */
    initialiserListesCubatures() {
        var leController = this;
        var cubaturesDepartArrivee = this.lireCubaturesDepartArrivee();
        this.cubaturesDepart = cubaturesDepartArrivee.cubaturesDepart;
        this.cubaturesArriveeSrc = cubaturesDepartArrivee.cubaturesArrivee;
        this.cubaturesArrivee = [];
        angular.forEach(leController.cubaturesArriveeSrc, function(cubatureArrivee, key) {
            leController.cubaturesArrivee[key] = cubatureArrivee;
            leController.cubaturesArrivee[cubatureArrivee.code] = cubatureArrivee;
            });
        jQuery.extend(this.cubaturesArrivee, this.cubaturesArriveeSrc); // on ne propose pas la même cubature au départ et à l'arrivée
        this.cubatureDepartCouches = [];
        this.cubatureDepartCouches[0] = new Object();
        this.cubatureDepartCouches[0].num = 0;
        this.cubatureDepartCouches[0].id = 0;
        this.cubatureDepartCouches[0].nom = "Choisissez une couche";
        this.cubatureArriveeCouches = [];
        this.cubatureArriveeCouches[0] = new Object();
        this.cubatureArriveeCouches[0].num = 0;
        this.cubatureArriveeCouches[0].id = 0;
        this.cubatureArriveeCouches[0].nom = "Choisissez une couche";
    }

    /*
    * on prépare les combos de cubatures de départ et d'arrivées possibles
    */
	lireCubaturesDepartArrivee() {
        var etude = this.etude;
        var cubaturesExo = etude.chantier.cubatures;
        /* NON ON NE VEUT PAS STOCKER, CA PEUT CHANGER TOUT LE TEMPS
        if (typeof(this.chantier.cubaturesDepartArrivee) != 'undefined') {
            return(this.chantier.cubaturesDepartArrivee);
        }
        */
        var cubaturesTypes = this.cubaturestypes;
        var cubaturesDepartArrivee = new Object();
        //this.chantier.cubaturesDepartArrivee = cubaturesDepartArrivee;
        cubaturesDepartArrivee.cubaturesDepart = [];
        cubaturesDepartArrivee.cubaturesArrivee = [];

        var cptCubaturesDepart = 0;
        var cptCubaturesArrivee = 0;
        jQuery.each(cubaturesExo, function(c, cubatureExo) {
            if (typeof(cubatureExo) == 'undefined') {
                return true;
            }
            var cubatureType = cubaturesTypes["id"+cubatureExo.const_cubaturestypes_id];
            if (cubatureType.code == "R") {
                cubatureExo.resultats.volumeDeblai = 0;
                cubatureExo.resultats.volumeRemblai = cubatureExo.volume;
            }
            if (cubatureType.code == "R+") {
                cubatureExo.resultats.volumeDeblai = cubatureExo.volumePurge;
                cubatureExo.resultats.volumeRemblai = cubatureExo.volume;
            }
            if (cubatureType.code == "D") {
                cubatureExo.resultats.volumeDeblai = cubatureExo.volume;
                cubatureExo.resultats.volumeRemblai = 0;
            }

            if (cubatureType.code == "DP") {
                cubatureExo.resultats.volumeRemblai = cubatureExo.volume;
                cubatureExo.resultats.volumeDeblai = cubatureExo.volume;
            }
            if (cubatureType.code == "DD") {
                cubatureExo.resultats.volumeRemblai = cubatureExo.volume;
                cubatureExo.resultats.volumeDeblai = 0;
            }
            if (cubatureType.code == "ST") {
                // a priori, un stock peut-être utilisé en déblai ou en remblai
                // attention, si un même stock est utilisé en déblai ET en remblai sur le même chantier alors
                // quelle différence entre stock et DP ?
                // du coup, je dirais qu'un même stock et utilisé pour l'un OU l'autre MAIS PAS les deux
                // c'est fait dans "mouvementValidate"
                cubatureExo.resultats.volumeRemblai = cubatureExo.volume;
                cubatureExo.resultats.volumeDeblai = cubatureExo.volume;
            }

            if (cubatureExo.resultats.volumeDeblai) {
                    cubaturesDepartArrivee.cubaturesDepart[cptCubaturesDepart] = cubatureExo;
                    cubaturesDepartArrivee.cubaturesDepart[cubatureExo.code] = cubatureExo;
                    cptCubaturesDepart++;
            }
            if (cubatureExo.resultats.volumeRemblai) {
                    cubaturesDepartArrivee.cubaturesArrivee[cptCubaturesArrivee] = cubatureExo;
                    cubaturesDepartArrivee.cubaturesArrivee[cubatureExo.code] = cubatureExo;
                    cptCubaturesArrivee++;
            }

        });
        return(cubaturesDepartArrivee);
    }



/*
* création du code en fonction du num et du code
*/
    coderCubature(id, num) {
        if (typeof(num) == 'undefined') {
            return(" ");
        }

        var code = "";
        if (id != "") {
            var typeCubature = this.cubaturestypes["id"+id];
            var code = typeCubature.code;
            if (code == "R+") {
                code = "R";
            }
        }
        if (num != "" && num < 10) {
            num = "0"+num;
        }
        return(code+num);
    }

/*
*
*/
    autoriserPurgeOuPasCouchesOuPas() {
        this.typeNewCubature = this.cubaturestypes["id"+this.newCubature.const_cubaturestypes_id];
        var code = this.typeNewCubature.code;
        if (code == "R+") {
            this.purgePossible = true;
        }
        else {
            this.purgePossible = false;
        }
        if (this.typeNewCubature.code == 'D' || this.typeNewCubature.code == 'R' || this.typeNewCubature.code == 'R+') {
            this.couchesMultiplesPossibles = true;
        }
        else {
            this.couchesMultiplesPossibles = false;
        }
    }
/*
* Saisie d'un type de cubature, on transforme le code mais surtout on vide le num
*/
    cubatureChangeType() {
        // On modifie le code automatiquement
        // this.newCubature.num = ""; finalement on conserve le numéro, c'est à l'élève de changer si besoin
        this.newCubature.code = this.coderCubature(this.newCubature.const_cubaturestypes_id, this.newCubature.num);
        this.autoriserPurgeOuPasCouchesOuPas();
        if (this.newCubature.const_cubaturestypes_id && this.newCubature.num) {
            this.newCubature.nom = this.cubaturestypes["id"+this.newCubature.const_cubaturestypes_id].nom+ " "+this.newCubature.code;
            }
    }

/*
* Saisie d'un numéro de cubature, on transforme le code
*/
    cubatureChangeNum() {
        // On modifie le code automatiquement
        this.newCubature.code = this.coderCubature(this.newCubature.const_cubaturestypes_id, this.newCubature.num);
        if (this.newCubature.const_cubaturestypes_id && this.newCubature.num) {
            this.newCubature.nom = this.cubaturestypes["id"+this.newCubature.const_cubaturestypes_id].nom+ " "+this.newCubature.code;
            }
    }

    cubaturechangeKmdebut() {

    }
    cubaturechangeKmfin() {

    }

/*
* Si la cubature est remplie correctement, on peut la valider
*/
cubatureIsDataValid() {

    var leController = this;

    if ((typeof(this.newCubature) == 'undefined')
        || (typeof(this.newCubature.const_cubaturestypes_id) == 'undefined')
        || (typeof(this.newCubature.num) == 'undefined')
        || (typeof(this.newCubature.kmdebut) == 'undefined')
        || (typeof(this.newCubature.kmfin) == 'undefined') ) {
          return(false);
      }

    if ((this.newCubature.const_cubaturestypes_id === "") || (this.newCubature.num === "") || (this.newCubature.nom === "")) {
          return(false);
      }
    if (this.newCubature.num < 1) {
          return(false);
      }

    if (this.couchesMultiplesPossibles) {

        if (this.newCubature.kmdebut < 0) {
          return(false);
        }

          if ((this.newCubature.kmdebut === "") || (this.newCubature.kmfin === 0)) {
              return(false);
          }
          if (this.newCubature.kmfin <= this.newCubature.kmdebut) {
              // message ? stockage dans analyse ?
              return(false);
          }
      }

    var retour = this.newCubatureCouches.every(function(item) {
            if ((typeof(item.volume) == 'undefined') || (typeof(item.const_sols_id) == 'undefined') || (typeof(item.ordre) == 'undefined') ) {
                return(false);
            }
           if (leController.typeNewCubature.code == "DD") {
               return((item.volume != "") && (item.volume != 0)); // on ne veut pas de 0
           }
           else {
                return((item.volume != "") && (item.volume != 0) && (item.const_sols_id != "0")); // on ne veut pas de 0
           }
       });
    return(retour);
  }

/*
* retrouver une cubature à partir de son code
*/
initialiserCubatureTmp(code) {
    var cubature;
    this.cubatures.forEach(item => {
        if (item.code == code) {
            cubature = item;
        }
    });

    if (typeof(cubature) !== 'undefined') {
        cubature.cubatureCouches=[];
        this.cubaturesCouches.forEach(item => {
            if (item.simuexo_cubatures_id == cubature.id) {
                cubature.cubatureCouches[cubature.cubatureCouches.length] = item;
            }
        });
    }
    return(cubature);
}

/*
* retrouver une cubature à partir de son id
*/
getCubature(id) {
    var cubature;
    this.cubatures.forEach(item => {
        if (item.id == id) {
            cubature = item;
        }
    });

    return(cubature);
}

 /*
* retrouver une cubature à partir de son id
*/
getCubatureCouche(id) {
    var couche;
    this.cubaturesCouches.forEach(item => {
        if (item.id == id) {
            couche = item;
        }
    });

    return(couche);
}

/*
* retrouver un mouvement à partir de son code
*/
initialiserMouvementTmp(code) {
    var mouvement;
    this.mouvements.forEach(item => {
        if (item.code == code) {
            mouvement = item;
        }
    });
    return(mouvement);
}
/*
* retrouver un mouvement à partir de son id
*/
getMouvement(id) {
    var mouvement;
    this.mouvements.forEach(item => {
        if (item.id == id) {
            mouvement = item;
        }
    });

    return(mouvement);
}

/*
*
*/
initialiserCubatureMouvementTmp(idMouvement, idCubature) {
    var mouvementCubature;
    this.cubaturesMouvements.forEach(item => {
        if ((item.simuexo_mouvements_id == idMouvement) && (item.simuexo_cubatures_id == idCubature)) {
            mouvementCubature = item;
        }
    });
    return(mouvementCubature);
}

/*
*
*/
modifierCubature(codeCub) {
    this.initialiserNewCubature(codeCub);
    this.addCubature(true);
}

    // réaction aux actions de type ng-click="SchemaEpureController.clickMouvement('M02') dans le template

    clickMouvement(codeMvt) {
        if (this.isAddingMouvement) {
            alert("Pour accéder au mouvement, vous devez d'abord valider ou abandonner votre saisie en cours.");
            return;
        }
        /*
        if (this.parentSimulator.etapeParametrageMouvementsValide) {
            this.doOnCheckParametrageMouvementsValid(false);
        }
        */
        this.modifierMouvement(codeMvt);
        this.doOnCheckParametrageMouvementsValid(false);
        /*
        if (this.parentSimulator.etapeParametrageCubaturesValide) {
            this.modifierMouvement(codeMvt);
            this.doOnCheckParametrageMouvementsValid(false);
        }
        else {
            alert("Pour accéder à votre mouvement, vous devez d'abord indiquer que la saisie des cubatures est valide.")
        }
        */
      }

    // réction au ng-click="SchemaEpureController.clickCubature('DPO1')
    clickCubature(codeCub) {
        if (this.isAddingCubature) {
            alert("Pour accéder à la cubature, vous devez d'abord valider ou abandonner votre saisie en cours.");
            return;
        }

        if ((!this.parentSimulator.etapeParametrageCubaturesValide) || (!this.isAddingMouvement)) {
            this.modifierCubature(codeCub);
            this.doOnCheckParametrageMouvementsValid(false);
            this.doOnCheckParametrageCubaturesValid(false);
        }
        else {
            var doScroll = true
            var cubatureTmp = this.initialiserCubatureTmp(codeCub);
            this.parentSimulator.setCurrentCubature(cubatureTmp, doScroll);
        }
    }

    /*
    *
    */
    initialiserNewMouvement(codeMvt = 0) {

        //this.exo_chantiers_id = TerrassorConst.chantierId;


        this.newMouvement = new Object();
        this.newCubaturesMouvements = [];

        if (codeMvt) {

            if (typeof(this.etude) == 'undefined') {
                //alert ("pas normal");
                this.etude = get_Terrassor_INTERFACE().etude;
                this.initialiserListesCubatures();
            }

            //var chantier = this.etude.chantier;

            // reinit mouvement
            this.initialiserNewMouvement(); // semi récurrence - on initialise correctement
            var mouvementTmp = this.initialiserMouvementTmp(codeMvt);
            if (!mouvementTmp.reglage) {

                var simuexo_cubatures_depart_id = mouvementTmp.simuexo_cubatures_depart_id;
                var simuexo_cubatures_arrivee_id = mouvementTmp.simuexo_cubatures_arrivee_id;

                jQuery.extend(this.newMouvement, mouvementTmp);
                this.newMouvement.num = Number(this.newMouvement.code.substr(this.newMouvement.code.length-2,2));

                // reinit mouvement/cubature
                var cubatureMouvementDepartTmp = this.initialiserCubatureMouvementTmp(mouvementTmp.id, simuexo_cubatures_depart_id);
                var cubatureMouvementArriveeTmp = this.initialiserCubatureMouvementTmp(mouvementTmp.id, simuexo_cubatures_arrivee_id);

                this.newCubaturesMouvements["depart"] = cubatureMouvementDepartTmp;
                this.newCubaturesMouvements["arrivee"] = cubatureMouvementArriveeTmp;
                this.cubatureDepartCode = this.getCubature(simuexo_cubatures_depart_id).code;
                this.cubatureArriveeCode = this.getCubature(simuexo_cubatures_arrivee_id).code;
            }
            else {
                // si reglage : tout est vide sauf le code, le nom, l'id, la distance et le ... reglage :-)
                jQuery.extend(this.newMouvement, mouvementTmp);
            }
        }
        else {
            this.cubatureDepartCode = "";
            this.cubatureArriveeCode = "";
            this.newMouvement.id = 0; // à gerer via la base !?!
            this.newMouvement.exo_chantiers_id = this.exo_chantiers_id;
            this.newMouvement.num = "";
            this.newMouvement.code = "";
            this.newMouvement.nom = "";
            this.newMouvement.volume = "";
            this.newMouvement.simuexo_cubatures_depart_id = "";
            //this.newMouvement.cubatureDepartCouche = "0";
            this.newMouvement.simuexo_cubatures_couches_depart_id = "0";
            this.newMouvement.const_sol_id = "";
            this.newMouvement.simuexo_cubatures_arrivee_id = "";
            //this.newMouvement.cubatureArriveeCouche = "0";
            this.newMouvement.simuexo_cubatures_couches_arrivee_id = "0";
            this.newMouvement.distance = "";
            this.newMouvement.preparationtraitementdemande = false;
            this.newMouvement.transformationdemandee = false;
            this.newMouvement.stopautoavant = false;
            this.newMouvement.stopautoapres = false;
            this.newMouvement.reglage = 0;
            this.newMouvement.description = "";
            this.newMouvement.valid = 0;

            this.newCubaturesMouvements["depart"] = new Object();
            this.newCubaturesMouvements["depart"].id = 0; // à gerer via la base !?!
            this.newCubaturesMouvements["depart"].simuexo_cubatures_id = "";
            this.newCubaturesMouvements["depart"].simuexo_cubatures_couches_id = "";
            this.newCubaturesMouvements["depart"].simuexo_mouvements_id = "";
            this.newCubaturesMouvements["depart"].ordre = "";
            this.newCubaturesMouvements["depart"].sens_inverse = false;
            this.newCubaturesMouvements["depart"].valid = 1;
            this.newCubaturesMouvements["arrivee"] = new Object();
            this.newCubaturesMouvements["arrivee"].id = 0; // à gerer via la base !?!
            this.newCubaturesMouvements["arrivee"].simuexo_cubatures_id = "";
            this.newCubaturesMouvements["arrivee"].simuexo_cubatures_couches_id = "";
            this.newCubaturesMouvements["arrivee"].simuexo_mouvements_id = "";
            this.newCubaturesMouvements["arrivee"].ordre = "";
            this.newCubaturesMouvements["arrivee"].sens_inverse = false;
            this.newCubaturesMouvements["arrivee"].valid = 1;
        }
    }

    addMouvement(modif = false) {
        this.isAddingMouvementModif = modif;
        this.isAddingMouvement = true;
    }
    mouvementChangeNum() {
        var debutCode = "M"
        var debutMouvement = "Mouvement "
        /*
        this.newMouvement.num = Math.max(1, this.newMouvement.num)
        this.newMouvement.num = Math.min(99, this.newMouvement.num)
*/
        if (this.newMouvement.num < 10) {
            debutCode = "M0"
        }

        var num = this.newMouvement.num;
        if (typeof(num) == 'undefined') {
            num = " ";
        }

      this.newMouvement.code = debutCode+num;
      this.newMouvement.nom = "Mouvement "+this.newMouvement.code;
    }
    changeVolume() {
    }

    /*
    *
    */
    creerCubatureCouche(objSol, idETnum, idCouche) {
        var cubatureCouche = new Object();
        cubatureCouche.code = objSol.code;
        cubatureCouche.coeffoisonnement = objSol.coeffoisonnement;
        cubatureCouche.coefremplissage = objSol.coefremplissage;
        cubatureCouche.equivalencegtr = objSol.equivalencegtr;
        cubatureCouche.id = idCouche;
        cubatureCouche.id_sol = objSol.id;
        cubatureCouche.massevolumique = objSol.massevolumique;
        cubatureCouche.nom = objSol.nom;
        cubatureCouche.num = idETnum
        return(cubatureCouche);
    }

    /*
    * Ne fait rien pour le moment, mais pourrait permettre le nettoyage des valeurs cachées au clic (qui réapparaissent donc au clic)
    */
    mouvementChangeReglage() {
    }

    /*
    * choix d'une cubature de départ dans le formulaire : on remplit le combo des couches disponibles
    */
    changeCubatureDepart() {
        var leController = this;
        //leController.newMouvement.cubatureDepartCouche = "0";
        leController.newMouvement.const_sol_id = "";
        leController.cubatureDepartCouches = [];
        leController.cubatureDepartCouches[0] = new Object();
        leController.cubatureDepartCouches[0].num = 0;
        leController.cubatureDepartCouches[0].id = 0;
        leController.cubatureDepartCouches[0].nom = "Choisissez une couche";
        leController.newMouvement.simuexo_cubatures_couches_depart_id = "0";
        if (leController.cubatureDepartCode == "") {
            return;
        }
        leController.newMouvement.simuexo_cubatures_depart_id = leController.cubaturesDepart[leController.cubatureDepartCode].id;
        var cubatureSelectionnee = leController.cubaturesDepart[leController.cubatureDepartCode];
       /* if (typeof(cubatureSelectionnee.tranchesDeblaiSols) == 'undefined') {
            return;
            }
        else {*/
            var cpt = 1;

            // attention aux purges : si on est en R+ - déblai possible sur première couche
            if (cubatureSelectionnee.purge) {
                leController.cubatureDepartCouches[cpt] = this.creerCubatureCouche(leController.sols["id"+cubatureSelectionnee.cubaturesCouches[0].const_sols_id], cpt, cubatureSelectionnee.cubaturesCouches[0].id);
                cpt++;
            }
            else { // sinon toutes les couches sont possibles
                var decalage = 0;
                if (cubatureSelectionnee.cubaturesCouches.length == 1) { // si une seule couche, on la donne par défault
                    decalage = 1;
                }
                angular.forEach(cubatureSelectionnee.cubaturesCouches, function(cubatureCouche, key) {
                    leController.cubatureDepartCouches[cpt-decalage] = leController.creerCubatureCouche(leController.sols["id"+cubatureCouche.const_sols_id], cpt, cubatureCouche.id);
                    cpt++;
                    });
                if (cubatureSelectionnee.cubaturesCouches.length == 1) { // si une seule couche, on la donne par défault
                    leController.newMouvement.simuexo_cubatures_couches_depart_id = "" + leController.cubatureDepartCouches[0].id;
                    leController.changeCubatureDepartCouche();
                }
            }

        // reinitialisation
        leController.cubaturesArrivee = [];
        cpt=0;
        angular.forEach(leController.cubaturesArriveeSrc, function(cubatureArrivee, key) {
            if (cubatureArrivee.id != leController.newMouvement.simuexo_cubatures_depart_id) {
                leController.cubaturesArrivee[cpt] = cubatureArrivee;
                leController.cubaturesArrivee[cubatureArrivee.code] = cubatureArrivee;
                cpt++;
                }
            });

        leController.cubatureArriveeCode = "";
        leController.newMouvement.simuexo_cubatures_arrivee_id = "";
        this.changeCubatureArrivee();
    }

    changeCubatureDepartCouche() {
        var leController = this;
        if (this.newMouvement.simuexo_cubatures_couches_depart_id == "0") {
            this.newMouvement.const_sol_id =  "";
        }
        else {
            leController.cubatureDepartCouches.forEach(couche => {
                if (couche.id == leController.newMouvement.simuexo_cubatures_couches_depart_id) {
                    leController.newMouvement.const_sol_id = couche.id_sol;
                }
            })

            // si on a la bonne couche à l'arrivée, on la donne par défaut
            leController.cubatureArriveeCouches.forEach(couche => {
                if (couche.id_sol == leController.newMouvement.const_sol_id) {
                    leController.newMouvement.simuexo_cubatures_couches_arrivee_id = "" + couche.id;
                }
            })
        }
    }

    changeCubatureArrivee() {
        var leController = this;
        //leController.newMouvement.cubatureArriveeCouche = "0"; // A VIRER ?
        // leController.newMouvement.distance = ""; // non, on ne le fait pas, il faut laisser l'utilisateur se débrouiller
        leController.cubatureArriveeCouches = [];
        leController.cubatureArriveeCouches[0] = new Object();
        leController.cubatureArriveeCouches[0].num = 0;
        leController.cubatureArriveeCouches[0].id = 0;
        leController.cubatureArriveeCouches[0].nom = "Choisissez une couche";
        leController.newMouvement.simuexo_cubatures_couches_arrivee_id = "0";
        if (leController.cubatureArriveeCode == "") {
            return;
        }
        leController.newMouvement.simuexo_cubatures_arrivee_id =  leController.cubaturesArrivee[leController.cubatureArriveeCode].id;
        var cubatureSelectionnee = leController.cubaturesArrivee[leController.cubatureArriveeCode];

        var cpt = 1;
                // attention aux purges : si on est en R+ - remblai impossible sur première couche
        if (cubatureSelectionnee.purge) {
            angular.forEach(cubatureSelectionnee.cubaturesCouches, function(cubatureCouche, key) {
                if (cpt > 1) {
                    leController.cubatureArriveeCouches[cpt-1] = leController.creerCubatureCouche(leController.sols["id"+cubatureCouche.const_sols_id], cpt, cubatureCouche.id);
                }
                cpt++;
            });
        }
        else { // sinon toutes les couches sont possibles
            if (leController.cubaturesArrivee[leController.cubatureArriveeCode].codeCubatureType != "DD") {
                var decalage = 0;
                if (cubatureSelectionnee.cubaturesCouches.length == 1) { // si une seule couche, on la donne par défault
                    decalage = 1;
                }
                angular.forEach(cubatureSelectionnee.cubaturesCouches, function(cubatureCouche, key) {
                    leController.cubatureArriveeCouches[cpt-decalage] = leController.creerCubatureCouche(leController.sols["id"+cubatureCouche.const_sols_id], cpt, cubatureCouche.id);
                    cpt++;
                });
                if (cubatureSelectionnee.cubaturesCouches.length == 1) { // si une seule couche, on la donne par défault
                    leController.newMouvement.simuexo_cubatures_couches_arrivee_id = "" + leController.cubatureArriveeCouches[0].id;
                    leController.changeCubatureArriveeCouche();
                }
            }
            else { // sauf si dépôt définitif qui n'a pas de couche
                leController.cubatureArriveeCouches[0].num = -1;
                leController.cubatureArriveeCouches[0].id = 1;
                leController.cubatureArriveeCouches[0].nom = "Sol indifférent";
                leController.newMouvement.simuexo_cubatures_couches_arrivee_id = "" + leController.cubatureArriveeCouches[0].id;
            }
        }

        // si on a la bonne couche à l'arrivée, on la donne par défaut
        leController.cubatureArriveeCouches.forEach(couche => {
            if ((couche.id_sol != 'undefined') && couche.id_sol && (couche.id_sol == leController.newMouvement.const_sol_id)) {
                leController.newMouvement.simuexo_cubatures_couches_arrivee_id = "" + couche.id;
            }
        })

    }

    /*
    * ne sert à rien ?????
    */
    changeCubatureArriveeCouche() {
    }
    changeDistance() {
    }
    changePreparationTraitement() {
    }
    changeTransformation() {
    }

  mouvementIsDataValid() {
      if (typeof(this.newMouvement.distance) == 'undefined') {
          return(false);
      }
      if ((typeof(this.newMouvement.distance) == 'undefined') || (this.newMouvement.distance == "") || (this.newMouvement.distance == 0)) {
          return(false);
      }

      if (this.newMouvement.reglage) {
          return(true);
      }
      if ((typeof(this.newMouvement) == 'undefined')
          || (typeof(this.newMouvement.num) == 'undefined') || (typeof(this.newMouvement.volume) == 'undefined')
          || (typeof(this.newCubaturesMouvements["depart"].ordre) == 'undefined') || (typeof(this.newCubaturesMouvements["arrivee"].ordre) == 'undefined') ) {
          return(false);
      }
      if (this.newMouvement.nom == "") {
          return(false);
      }
      if ((this.newMouvement.volume == "") || (this.newMouvement.volume == 0)) {
          return(false);
      }
      if (this.newMouvement.const_sol_id == "") {
          return(false);
      }
      if ((this.newMouvement.simuexo_cubatures_couches_depart_id == "0") || (this.newMouvement.simuexo_cubatures_couches_arrivee_id == "0")) {
          return(false);
      }
      if ((this.newMouvement.simuexo_cubatures_depart_id == "") || (this.newMouvement.simuexo_cubatures_arrivee_id == ""))  {
          return(false);
      }
      if ((this.newCubaturesMouvements["depart"].ordre == "") || (this.newCubaturesMouvements["depart"].ordre == 0)) {
          return(false);
      }

      if ((this.newCubaturesMouvements["arrivee"].ordre == "") || (this.newCubaturesMouvements["arrivee"].ordre == 0)) {
          return(false);
      }

      return(true);
  }

    /*
    *
    */
  mouvementValidate() {
    var error = this.mouvementValidationImmediate()
    if (error) {
          alert(error);
    }
      else {
          // on efface tout
        this.isAddingMouvement = false;

        // puis enregistrement
        this.traiterNouveauMouvement(); // que le mouvement soit créé ou existe déjà : c'est pareil
      }
  }

    /*
    *
    */
  mouvementValidationImmediate(mouvementParam = null) {

      var leController = this;
      var leMouvement = this.newMouvement;
      if (mouvementParam) {
          leMouvement = mouvementParam;
      }

              // VALIDATION
      if (leMouvement.reglage) {
          var pbReglage = false;
          this.mouvements.forEach(mouvementTest => {
            if (mouvementTest.id != leMouvement.id) {
                if (mouvementTest.reglage) {
                    pbReglage = true;
                    }
                }
            });
          if (pbReglage) {
            return("Attention, il existe déjà un mouvement de réglage, vous ne pouvez pas en ajouter un deuxième.");
          }
          if (!mouvementParam) {
            // on nettoie le mouvement
            var id = leMouvement.id;
            var distance = leMouvement.distance;
            this.initialiserNewMouvement();
            this.newMouvement.id = id;
            this.newMouvement.distance = distance;
            this.newMouvement.reglage = true;
            this.newMouvement.code = "REG";
            this.newMouvement.nom = "Réglage";
            }
      }
      else {

      // on vérifie qu'il n'y a pas de problème de cohérence de code / id
      var mouvementTmp = this.initialiserMouvementTmp(leMouvement.code);
      if (typeof(mouvementTmp) !== 'undefined') {
          if (mouvementTmp.id != leMouvement.id) {
              return("Attention, le code que vous avez saisi pour ce mouvement existe déjà. Si vous souhaitez modifier un mouvement, cliquez sur son étiquette dans le schéma, sinon saisissez un autre code."); // TODO système de message en global ?
          }
      }

      // validations sur cubatures associées
      var cubatureDepart = this.getCubature(leMouvement.simuexo_cubatures_depart_id);
      var cubatureArrivee = this.getCubature(leMouvement.simuexo_cubatures_arrivee_id);
      var cubatureDepartType = this.cubaturestypes["id"+cubatureDepart.const_cubaturestypes_id];
      var cubatureArriveeType = this.cubaturestypes["id"+cubatureArrivee.const_cubaturestypes_id];

      // on interdit les mouvements de dépot / dépôt ou stock / dépôt
      if ( (cubatureDepartType.code == "DD" || cubatureDepartType.code == "DP" || cubatureDepartType.code == "ST")
          &&  (cubatureArriveeType.code == "DD" || cubatureArriveeType.code == "DP" || cubatureArriveeType.code == "ST") ) {
          return("Attention, les mouvements entre dépôts, entre stocks ou entre stocks et dépôts vous sont interdits");
      }

      // on interdit les purges hors d'un DD, DP ou STOCK
      if ( (cubatureDepart.purge)
          &&  (cubatureArriveeType.code != "DD" && cubatureArriveeType.code != "DP" && cubatureArriveeType.code != "ST") ) {
          return("Attention, les purges doivent se faire vers un dépôt ou un stock.");
      }

      // tests sur couches
      var coucheDepart = this.getCubatureCouche(leMouvement.simuexo_cubatures_couches_depart_id);
      var coucheArrivee = this.getCubatureCouche(leMouvement.simuexo_cubatures_couches_arrivee_id);

          var messageCode = "Mouvement "+leMouvement.code+" : ";
      // cohérence couches
      if (coucheDepart.const_sols_id != coucheArrivee.const_sols_id) {
          var messageTmp = messageCode + "attention, le sol que vous souhaitez déplacer ne correspond pas à la couche d'arrivée. Rappel : vous pouvez obtenir des information sur une cubature en cliquant son étiquette.";
          return(messageTmp);
      }

      // cohérence volume et volumes couches
      var volume = leMouvement.volume;
      if ((volume > coucheDepart.volume) ||  (volume > coucheArrivee.volume)) {
          var messageTmp = messageCode + "attention, le volume que vous souhaitez déplacer est trop important au regard des couches sélectionnées. Rappel : vous pouvez obtenir des information sur une cubature en cliquant son étiquette.";
          return(messageTmp);
      }


      // on vérifie qu'il n'existe pas déjà un mouvement de cette couche vers la même couche de destination
      var pbCouche2Couche = false;
      this.mouvements.forEach(mouvementTest => {
          if (!mouvementTest.reglage && (mouvementTest.id != leMouvement.id)) {
              var coucheDepartTest = leController.getCubatureCouche(mouvementTest.simuexo_cubatures_couches_depart_id);
              var coucheArriveeTest = leController.getCubatureCouche(mouvementTest.simuexo_cubatures_couches_arrivee_id);
              if ((coucheDepartTest.id == coucheDepart.id) && (coucheArriveeTest.id == coucheArrivee.id)) {
                  pbCouche2Couche = true;
              }
          }
      });
      if (pbCouche2Couche) {
          var messageTmp = messageCode + "attention, il existe déjà un mouvement de cette couche de départ vers cette couche d'arrivée. Cela vous est interdit, mais par la suite, vous pourrez créer plusieurs echelons sur un même mouvement.";
          return(messageTmp);
      }

      // on vérifie qu'un même stock n'est pas utilisé en départ et en arrivée
      var pbStock = false;
      if ((cubatureDepartType.code == "ST") || (cubatureArriveeType.code == "ST")) {
          this.mouvements.forEach(mouvementTest => {
              if (!mouvementTest.reglage && (mouvementTest.id != leMouvement.id)) {
                  var cubatureDepartTest = leController.getCubature(mouvementTest.simuexo_cubatures_depart_id);
                  var cubatureArriveeTest = leController.getCubature(mouvementTest.simuexo_cubatures_arrivee_id);
                  var cubatureDepartTestType = leController.cubaturestypes["id"+cubatureDepartTest.const_cubaturestypes_id];
                  var cubatureArriveeTestType = leController.cubaturestypes["id"+cubatureArriveeTest.const_cubaturestypes_id];
                  if ((cubatureDepartTestType.code == "ST") && (cubatureArriveeType.code == "ST")) {
                      pbStock = true;
                  }
                  if ((cubatureArriveeTestType.code == "ST") && (cubatureDepartType.code == "ST")) {
                      pbStock = true;
                  }
              }
          });
      }
      if (pbStock) {
          return("Attention, n'utilisez pas un même stock en déblai et remblai. Dans ce cas, préférez un dépôt provisoire.");
      }
      }
      return(0);
  }


    //*********************************
	triCubaturesCouchesEtCubaturesMouvements(x, y) {
        if (x.simuexo_cubatures_id == y.simuexo_cubatures_id) {
            return(x.ordre - y.ordre);
        }
        return(x.simuexo_cubatures_id - y.simuexo_cubatures_id);
    }

    //*********************************
	triCubaturesParKmfin(x, y) {
        return(x.kmfin - y.kmfin);
    }

    /*
    * on valide que l'élève peut passer à la suite
    * à ce jour les erreurs ne sont pas stockées
    */
    validerEpure() {

        
        if (typeof(this.etude) == 'undefined') {
            this.etude = get_Terrassor_INTERFACE().etude;
        }
        var etude = this.etude;
                
        var leController = this;
        var messageErreur = "";

        // on relance la validation "immédiate" des mouvements car une modification sur les cubatures a pu la rendre caduque
        var erreurValidationImmediate = false;
        var error = this.validerIncoherences();

        if (error) {
            messageErreur = error;
            // etude.erreurEpure(messageErreur);
            erreurValidationImmediate = true;
        }
        else {
            jQuery.each(leController.mouvements, function(c, mouvement) {
                error = leController.mouvementValidationImmediate(mouvement);
                if (error) {
                    erreurValidationImmediate = true;
                    messageErreur = error;
                    // etude.erreurEpure(error);
                    }
                });
            }


        if (!erreurValidationImmediate) {

            var erreurZero = false;
            if (leController.cubatures.length == 0) {
                erreurZero = true;
                messageErreur = "Attention, jusqu'à preuve du contraire, vous ne pouvez pas réaliser un chantier de terrassement sans cubature !!!";
                // etude.erreurEpure(messageErreur);
            }
            else {
                var cptCubaturesOK = 0;
                // il faut un déblai ou un remblai
                jQuery.each(this.cubatures, function(c, cubature) {
                    var cubatureTypeCode = leController.cubaturestypes["id"+cubature.const_cubaturestypes_id].code;
                    if ((cubatureTypeCode == "R+") || (cubatureTypeCode == "R") || (cubatureTypeCode == "D")) {
                        cptCubaturesOK++;
                    }
                })
                if (cptCubaturesOK == 0) {
                    erreurZero = true;
                    messageErreur = "Attention, jusqu'à preuve du contraire, vous ne pouvez pas réaliser un chantier de terrassement sans déblai ou remblai !!!";
                    // etude.erreurEpure(messageErreur);
                }
                else {
                    if (leController.mouvements.length == 0) {
                        erreurZero = true;
                        messageErreur = "Attention, jusqu'à preuve du contraire, vous ne pouvez pas réaliser un chantier de terrassement sans mouvement de terre !!!";
                        // etude.erreurEpure(messageErreur);
                    }
                }
            }

            // on tri par cubature puis par ordre pour la validation
            this.cubaturesCouches.sort(this.triCubaturesCouchesEtCubaturesMouvements);
            this.cubaturesMouvements.sort(this.triCubaturesCouchesEtCubaturesMouvements);

            var erreurDeblai = false;
            var erreurPurge = false;
            var erreurRemblai = false;

            // rappel : la matière est forcément bonne !

            // pour chaque cubature, est-ce que le volume à déblayer, à remblayer et à purger est compensé couche par couche par des mouvements ?
            jQuery.each(this.cubaturesCouches, function(c, cubatureCouche) {
                var volume = cubatureCouche.volume;
                var cubature = leController.getCubature(cubatureCouche.simuexo_cubatures_id);
                var cubatureTypeCode = leController.cubaturestypes["id"+cubature.const_cubaturestypes_id].code;
                if ((cubatureTypeCode == "R")/* || (cubatureTypeCode == "DD")*/) {
                    jQuery.each(leController.mouvements, function(c, mouvement) {
                        if (mouvement.simuexo_cubatures_couches_arrivee_id == cubatureCouche.id) {
                            volume -= mouvement.volume;
                            }
                        });
                    if (volume != 0) {
                        erreurRemblai = true;
                        messageErreur = "Attention, le remblai "+cubature.code+" n'est pas correctement réalisé. Vous devez vérifier le volume des mouvements qui lui sont associés";
                        // etude.erreurEpure(messageErreur);
                        }
                    }
                if (cubatureTypeCode == "D") {
                    jQuery.each(leController.mouvements, function(c, mouvement) {
                        if (mouvement.simuexo_cubatures_couches_depart_id == cubatureCouche.id) {
                            volume -= mouvement.volume;
                            }
                        });
                    if (volume != 0) {
                        erreurDeblai = true;
                        messageErreur = "Attention, le déblai "+cubature.code+" n'est pas correctement réalisé. Vous devez vérifier le volume des mouvements qui lui sont associés";
                        // etude.erreurEpure(messageErreur);
                        }
                    }
                if (cubatureTypeCode == "R+") {
                    if (cubatureCouche.purge) {
                        jQuery.each(leController.mouvements, function(c, mouvement) {
                            if (mouvement.simuexo_cubatures_couches_depart_id == cubatureCouche.id) {
                                volume -= mouvement.volume;
                                }
                            });
                        if (volume != 0) {
                            erreurDeblai = true;
                            messageErreur = "Attention, le déblai sur "+cubature.code+" n'est pas correctement réalisé. Vous devez vérifier le volume des mouvements qui lui sont associés";
                            // etude.erreurEpure(messageErreur);
                            }
                        }
                    else {
                        jQuery.each(leController.mouvements, function(c, mouvement) {
                            if (mouvement.simuexo_cubatures_couches_arrivee_id == cubatureCouche.id) {
                                volume -= mouvement.volume;
                                }
                            });
                        if (volume != 0) {
                            erreurRemblai = true;
                            messageErreur = "Attention, le remblai "+cubature.code+" n'est pas correctement réalisé. Vous devez vérifier le volume des mouvements qui lui sont associés";
                            // etude.erreurEpure(messageErreur);
                            }
                        }
                    }
                });

            // est-ce que l'ordre des mouvemenst est OK (cohérent avec l'ordre des couches + ... ?)
            // pour chaque cubature
            var erreurOrdre = false;
            jQuery.each(this.cubatures, function(c, cubature) {

                var cubatureTypeCode = leController.cubaturestypes["id"+cubature.const_cubaturestypes_id].code;

                var ordreAttenduMin = 1;
                var ordreAttenduMax = 1;
                var couchePred =  null;
                var mouvementPred =  null;
                // on regarde les mouvements associés à la cubature (rappel : triés par ordre)
                jQuery.each(leController.cubaturesMouvements, function(c, cubatureMouvement) {
                    if (cubature.id == cubatureMouvement.simuexo_cubatures_id) {
                        var ordre = cubatureMouvement.ordre;
                        var couche = leController.getCubatureCouche(cubatureMouvement.simuexo_cubatures_couches_id);
                        var mouvement = leController.getMouvement(cubatureMouvement.simuexo_mouvements_id);
                        // si on a changé de couche, on avance forcément sur les ordres
                        if (couchePred && (couchePred.id != couche.id)) {
                            ordreAttenduMin += 1;
                        }
                        else {
                            // si on passe d'un remblai à un déblai (ou d'un déblai à un remblai - purge), on avance forcément sur les ordres
                            if (mouvementPred && ( ((cubature.id == mouvement.simuexo_cubatures_arrivee_id) && (cubature.id == mouvementPred.simuexo_cubatures_depart_id))
                                                  || ((cubature.id == mouvementPred.simuexo_cubatures_arrivee_id) && (cubature.id == mouvement.simuexo_cubatures_depart_id))  )) {
                                ordreAttenduMin += 1;
                            }
                        }
                        if ((ordre < ordreAttenduMin) || (ordre > ordreAttenduMax)) {
                            erreurOrdre = true;
                            messageErreur = "Attention, l'ordre des mouvements n'est pas correct sur la cubature "+cubature.code;
                            // etude.erreurEpure(messageErreur);
                            }

                        ordreAttenduMin = ordre; // on peut peut-être avoir 2 mouvements en même temps
                        ordreAttenduMax = ordre+1;
                        couchePred = couche;
                        mouvementPred = mouvement;
                    }
                })
            })

            // test sur le non chevauchement des cubaturess
            var erreurChevauchement = false;
            this.cubatures.sort(this.triCubaturesParKmfin);
            //var kmdebut = 0;
            var kmfin = 0;
            jQuery.each(this.cubatures, function(c, cubature) {
                var cubatureTypeCode = leController.cubaturestypes["id"+cubature.const_cubaturestypes_id].code;
                if ((cubatureTypeCode == "R+") || (cubatureTypeCode == "R") || (cubatureTypeCode == "D")) {
                    if ((cubature.kmdebut > cubature.kmfin) || (cubature.kmdebut < kmfin)) {
                        erreurChevauchement = true;
                        messageErreur = "Attention, il y a un recouvrement entre vos cubatures, modifiez les PK de début et de fin pour que ça ne soit plus le cas.";
                        // etude.erreurEpure(messageErreur);
                        }
                    kmfin = cubature.kmfin;
                }
            })

        }


        if (erreurValidationImmediate || erreurZero || erreurDeblai || erreurPurge || erreurRemblai || erreurOrdre || erreurChevauchement) {

            this.doOnCheckParametrageMouvementsValid(false); // les mouvements ne sont plus valides

            var context = {"panel":"CREATIONEPURE", "data":null, "subData":null}
            var retour = new Object();
            retour.isCreationEpure = true;
            var errorMessage = new Object();
            errorMessage.context = "CREATIONEPURE"
            errorMessage.message = messageErreur
            errorMessage.type = 'error'
            errorMessage.visibility = true

            this.parentSimulator.reinitialiserMessageCreationEpure(errorMessage) // dans le module
            var errorMessageBis = new Object(); // format incompatibles ? :-(
            jQuery.extend(errorMessageBis, errorMessage); // on ne propose pas la même cubature au départ et à l'arrivée
            errorMessageBis.context = context
            this.parentSimulator.dispatchErrorMessage(errorMessage) // et en modal

            return(false);
        }

        return(true);
    }

    // ******************
  traiterNouveauMouvement() {
      var leController = this;

      this.newMouvement.valid = 1; // et on valide

      if (!this.newMouvement.reglage) {
          this.newCubaturesMouvements["depart"].simuexo_cubatures_id = this.newMouvement.simuexo_cubatures_depart_id;
          this.newCubaturesMouvements["depart"].simuexo_mouvements_id = this.newMouvement.id;
          this.newCubaturesMouvements["arrivee"].simuexo_cubatures_id = this.newMouvement.simuexo_cubatures_arrivee_id;
          this.newCubaturesMouvements["arrivee"].simuexo_mouvements_id = this.newMouvement.id;
          this.newCubaturesMouvements[0] = this.newCubaturesMouvements["depart"];
          this.newCubaturesMouvements[1] = this.newCubaturesMouvements["arrivee"];

          this.cubaturesCouches.forEach(function chercher(couche, index){
            if ((couche.simuexo_cubatures_id == leController.newMouvement.simuexo_cubatures_depart_id) && (couche.id == leController.newMouvement.simuexo_cubatures_couches_depart_id)){
                leController.newCubaturesMouvements[0].simuexo_cubatures_couches_id = couche.id;
            }
            if ((couche.simuexo_cubatures_id == leController.newMouvement.simuexo_cubatures_arrivee_id) && (couche.id == leController.newMouvement.simuexo_cubatures_couches_arrivee_id)){
                leController.newCubaturesMouvements[1].simuexo_cubatures_couches_id = couche.id;
            }
          })
      }

      if (this.newMouvement.reglage) {
            // si on a un id sur un réglage, il ne faut pas conserver de CubaturesMouvements
            if (this.newMouvement.id) {
                this.detruireMouvementCubatures(this.newMouvement);
            }
          return this.ApiSimu.saveSimuExoMouvements(this.newMouvement)
            .then(newMouvement => {
                this.newMouvement.id = newMouvement.id;
                this.majMouvements(this.newMouvement);
          })
      }
      else {
        return this.ApiSimu.saveSimuExoMouvements(this.newMouvement)
            .then(newMouvement => {
                if (typeof(newMouvement) !== 'undefined') {
                    this.newMouvement.id = newMouvement.id;
                    this.newCubaturesMouvements[0].simuexo_mouvements_id = newMouvement.id;
                    this.newCubaturesMouvements[1].simuexo_mouvements_id = newMouvement.id;
                    //var allPromises = [];
                    //var leController = this;
                    return this.ApiSimu.saveSimuExoMouvementsCubatures(this.newCubaturesMouvements[0])
//                    return this.ApiSimu.saveSimuExoMouvementCubatureEleve(this.newCubaturesMouvements[0])
                        .then(newMouvementCubature0 => {
                            if (typeof(newMouvementCubature0) !== 'undefined') {
                                this.newCubaturesMouvements[0].id = newMouvementCubature0.id;
                                return this.ApiSimu.saveSimuExoMouvementsCubatures(this.newCubaturesMouvements[1])
                                //return this.ApiSimu.saveSimuExoMouvementCubatureEleve(this.newCubaturesMouvements[1])
                                    .then(newMouvementCubature1 => {
                                        if (typeof(newMouvementCubature1) !== 'undefined') {
                                            this.newCubaturesMouvements[1].id = newMouvementCubature1.id;
                                            this.majMouvements(this.newMouvement, this.newCubaturesMouvements);
                                        }
                                    })
                                }
                            })
                    }
            })
      }
  }

    /*
    *
    */
    majMouvements(newMouvement, newCubaturesMouvements=null) {

            // 1 MOUVEMENTS
        // on ajoute ou on écrase
        var indexNewMouvement = this.mouvements.length; // si ajout
        this.mouvements.forEach(function chercher(mouvement, index){
            if (mouvement.id == newMouvement.id) {
                indexNewMouvement = index; // si ecrase
            }
        })
        this.mouvements[indexNewMouvement] = newMouvement;
        newMouvement.cubatureDepartCode = this.cubatureDepartCode; // ?
        newMouvement.cubatureArriveeCode = this.cubatureArriveeCode; // ?

        // 2 CUBATURES / MOUVEMENTS
        if (newCubaturesMouvements) {
            var leController = this;

            var indexNewCubatureMouvementDepart = leController.cubaturesMouvements.length; // si ajout
            var indexNewCubatureMouvementArrivee = indexNewCubatureMouvementDepart+1; // si ajout
            leController.cubaturesMouvements.forEach(function chercher(cubatureMouvement, index){
                if (cubatureMouvement.id == leController.newCubaturesMouvements["depart"].id) {
                    indexNewCubatureMouvementDepart = index;
                }
                if (cubatureMouvement.id == leController.newCubaturesMouvements["arrivee"].id) {
                    indexNewCubatureMouvementArrivee = index;
                }
            })
            leController.cubaturesMouvements[indexNewCubatureMouvementDepart] = leController.newCubaturesMouvements["depart"];
            leController.cubaturesMouvements[indexNewCubatureMouvementArrivee] = leController.newCubaturesMouvements["arrivee"];
        }

        // et on reinitialise
        this.initialiserNewMouvement();

        // puis affichage
        this.afficherEpure();
  }

    /*
    *
    */
    detruireMouvement(mouvement) {
        var leController = this;

        // on detruit le mouvement
        leController.ApiSimu.deleteSimuExoMouvements(mouvement) // en base
        var i;
        for (i = this.mouvements.length - 1; i >= 0; i -= 1) { // puis dans l'objet courant
            var item = this.mouvements[i];
            if (item.id == mouvement.id) {
                this.mouvements.splice(i, 1)
            }
        }
        this.detruireMouvementCubatures(mouvement)
    }

    /*
    *
    */
    detruireMouvementCubatures(mouvement) {
        var leController = this;
        // on detruit les assos
        var i;
        for (i = this.cubaturesMouvements.length - 1; i >= 0; i -= 1) { // puis dans l'objet courant
            var item = this.cubaturesMouvements[i];
            if (item.simuexo_mouvements_id == mouvement.id) {
                leController.ApiSimu.deleteSimuExoMouvementsCubatures(item);
                this.cubaturesMouvements.splice(i, 1);
            }
        }
    }

/*
*
*/
  mouvementDelete() {
        var leMessageConfirmation = "Voulez-vous vraiment supprimer ce mouvement ?";
        if (confirm(leMessageConfirmation)) {
            this.isAddingMouvement = false;
            this.detruireMouvement(this.newMouvement);
            // et on reinitialise
            this.initialiserNewMouvement();

        // puis affichage
        this.afficherEpure();
        }
  }

/*
*
*/
  mouvementCancel() {
      this.isAddingMouvement = false;
      this.initialiserNewMouvement();
  }

/*
*
*/
    modifierMouvement(codeMvt) {
        this.initialiserNewMouvement(codeMvt);

        if (!this.newMouvement.reglage) {
            // on sauvegarde
            var cubatureDepartCode = this.cubatureDepartCode;
            var cubatureArriveeCode = this.cubatureArriveeCode;
            var simuexo_cubatures_arrivee_id = this.newMouvement.simuexo_cubatures_arrivee_id;
            var simuexo_cubatures_couches_depart_id = this.newMouvement.simuexo_cubatures_couches_depart_id;
            var simuexo_cubatures_couches_arrivee_id = this.newMouvement.simuexo_cubatures_couches_arrivee_id;

            this.changeCubatureDepart();

            // et on remet pour les couches départ
            this.newMouvement.simuexo_cubatures_couches_depart_id = simuexo_cubatures_couches_depart_id;
            this.changeCubatureDepartCouche();

            // et on pour l'arrivée
            this.cubatureArriveeCode = cubatureArriveeCode;
            this.newMouvement.simuexo_cubatures_arrivee_id = simuexo_cubatures_arrivee_id;
            this.changeCubatureArrivee();
            this.newMouvement.simuexo_cubatures_couches_arrivee_id = simuexo_cubatures_couches_arrivee_id;

            this.changeCubatureArriveeCouche(); // inutile mais bon ...
        }

        this.addMouvement(true);
    }

}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/schema-epure-creer/schema-epure-creer.controller.js